/**
 *
 *           # Redirect specific paths
 *
 *           # /de/
 *           rewrite ^/de/blog/naturcamping$ /de/ permanent;
 *
 *           # /de/stellplatz-app/
 *           rewrite ^/de/blog/camper-apps-im-vergleich$ /de/stellplatz-app/ permanent;
 *           rewrite ^/de/blog/camping-apps$ /de/stellplatz-app/ permanent;
 *           rewrite ^/de/wohnmobil-stellplatz-app$ /de/stellplatz-app/ permanent;
 *
 *           # /de/zeltplatz/
 *           rewrite ^/de/blog/camping-mit-zelt$ /de/zeltplatz/ permanent;
 *
 *           # /de/camping-mit-hund/
 *           rewrite ^/de/blog/camping-mit-hund$ /de/camping-mit-hund/ permanent;
 *
 *           # /de/zeltplatz/ostsee/
 *           rewrite ^/de/blog/stellplaetze-an-der-ostsee$ /de/zeltplatz/ostsee/ permanent;
 */
import NamedRedirect from './components/NamedRedirect/NamedRedirect';

const redirects = [
  {
    path: '/press',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'news-und-presse' }} />,
  },
  {
    path: '/25pass',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'pass', rest: '25pass' }} />
    ),
  },
  {
    path: '/camping-mit-hund',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'mit-hund' }} />
    ),
  },
  {
    path: '/blog/camping-routine-in-deutschland',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'deutschland' }} />
    ),
  },
  {
    path: '/blog/stellplaetze-alpaka-wanderung',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'alpaka' }} />
    ),
  },
  {
    path: '/blog/camper-apps-im-vergleich',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'stellplatz-app' }} />,
  },
  {
    path: '/blog/camping-apps',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'stellplatz-app' }} />,
  },
  {
    path: '/wohnmobil-stellplatz-app',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'stellplatz-app' }} />,
  },
  {
    path: '/blog/camping-mit-zelt',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'zeltplatz' }} />,
  },
  {
    path: '/blog/camping-mit-hund',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'camping-mit-hund' }} />,
  },
  {
    path: '/blog/camping-am-meer',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'am-meer' }} />
    ),
  },
  {
    path: '/blog/campen-und-wandern',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'deutschland' }} />
    ),
  },
  {
    path: '/blog/campen-auf-dem-bauernhof',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'camping', rest: 'auf-dem-bauernhof' }} />
    ),
  },
  {
    path: '/blog/stellplaetze-an-der-ostsee',
    component: () => (
      <NamedRedirect name="StoryblokPage" params={{ slug: 'zeltplatz', rest: 'ostsee' }} />
    ),
  },
  {
    path: '/blog/stellplaetze-bayern',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'bayern' }}
      />
    ),
  },
  {
    path: '/blog/stellplaetze-in-hamburg',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'hamburg' }}
      />
    ),
  },
  {
    path: '/blog/camping-in-der-toskana',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'italien' }}
      />
    ),
  },
  {
    path: '/blog/stellplaetze-oesterreich',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'oesterreich' }}
      />
    ),
  },
  {
    path: '/blog/stellplaetze-schweiz',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'schweiz' }}
      />
    ),
  },
  {
    path: '/blog/wohnmobilstellplaetze-deutschland',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'deutschland' }}
      />
    ),
  },
  {
    path: '/blog/mit-dem-wohnmobil-nach-spanien',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'spanien' }}
      />
    ),
  },
  {
    path: '/blog/mit-dem-wohnmobil-nach-spanien',
    component: () => (
      <NamedRedirect
        name="StoryblokPage"
        params={{ slug: 'wohnmobilstellplatz', rest: 'spanien' }}
      />
    ),
  },
  {
    path: '/app',
    component: () => <NamedRedirect name="StoryblokPage" params={{ slug: 'stellplatz-app' }} />,
  },
  // Legacy draft listing URLs (e.g. /l/draft/<uuid>/new/description) from old CMS content and
  // external links. The edit flow moved to /e/:slug/:id/:type/:tab, so these fell through to
  // ListingPageVariant and rendered the not found page.
  {
    path: '/l/draft/:id/:type/:tab',
    component: () => <NamedRedirect name="NewListingPage" />,
  },
];

export default redirects;
